import React, { useState } from 'react';
import FieldError from '../utils/FieldError';

const CamposUsuario = ({ form, onChange, soloPassword = false, errors = {} }) => {
    const [mostrarPassword, setMostrarPassword] = useState(false);

    const togglePassword = () => {
        setMostrarPassword((prev) => !prev);
    };

    return (
        <div className="space-y-4">
            {!soloPassword && (
                <>
                    <div className="space-y-1">
                        <label className="block text-sm font-medium text-gray-700">Email:</label>
                        <input type="email" name="email" value={form.email} disabled className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm bg-gray-100 text-gray-500 cursor-not-allowed" />
                    </div>
                    <div className="space-y-1">
                        <label className="block text-sm font-medium text-gray-700">DNI:</label>
                        <input type="text" name="dni" value={form.dni} disabled className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm bg-gray-100 text-gray-500 cursor-not-allowed" />
                    </div>
                    <div className="space-y-1">
                        <label className="block text-sm font-medium text-gray-700">Nombre:</label>
                        <input type="text" name="firstName" value={form.firstName} onChange={onChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                        <FieldError message={errors.firstName} />
                    </div>
                    <div className="space-y-1">
                        <label className="block text-sm font-medium text-gray-700">Apellido:</label>
                        <input type="text" name="lastName" value={form.lastName} onChange={onChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                        <FieldError message={errors.lastName} />
                    </div>
                </>
            )}
            <div className="space-y-1">
                <label className="block text-sm font-medium text-gray-700">Contraseña nueva:</label>
                <div className="relative">
                    <input type={mostrarPassword ? 'text' : 'password'} name="password" value={form.password} onChange={onChange} required
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                    <button type="button" onClick={togglePassword}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-primary-600 hover:text-primary-700"
                        title={mostrarPassword ? 'Ocultar' : 'Mostrar'}>
                        {mostrarPassword ? '🙈' : '👁️'}
                    </button>
                </div>
                <FieldError message={errors.password} />
            </div>
        </div>
    );
};

export default CamposUsuario;
